import { useMemo } from "react"
import { useTranslation } from "react-i18next"

import type { AlertSettingParam } from "types/alerts.types"

import { formatSelectTelemetries, getEntityTelemetries } from "helpers/utils/telemetries"
import TelemetryInput from "../TelemetryInput"

interface PowerlineTelemetryInputProps {
  param: AlertSettingParam
}

const PowerlineTelemetryInput = ({ param }: PowerlineTelemetryInputProps) => {
  const { t } = useTranslation()

  const telemetries = useMemo(() => getEntityTelemetries("powerline"), [])
  const selectTelemetries = useMemo(
    () => formatSelectTelemetries(telemetries, t) || [],
    [telemetries, t],
  )

  return <TelemetryInput param={param} telemetries={selectTelemetries} />
}

export default PowerlineTelemetryInput
